import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 35px;
  border: 1px solid
    ${({ theme, isValid }) => (isValid ? theme.colors.grey003 : theme.colors.redMain)};
  border-radius: 4px;

  ${({ leadingText, theme }) =>
    leadingText &&
    `
    &:before {
      content: '${leadingText}';
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      color: ${theme.colors.black};
      background-color: ${theme.colors.grey006};
      // border-top-left-radius: 4px;
      // border-bottom-left-radius: 4px;
      font-size: 14px;
    }
  `}

  &:after {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 100%;
    color: ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.grey006};
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 20px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  border: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: none;
    outline: none;
  }
`;
